import React from "react"
import types from "prop-types"
import { isEmpty } from "lodash-es"
import { useSelector } from "react-redux"
import { getClockFormat } from "reduxSlices/currentSettingsSlice"
import LocationDataElement from "shared/Table/TableDataElement/LocationDataElement"
import UsersAnswerDataElement from "shared/Table/TableDataElement/UsersAnswerDataElement"
import { timeByClockFormat, TWENTY_FOUR_HOUR_TIME_REGEX } from "utils/dateHelpers"
import { CLOCK_FORMAT_TWELVE_HOUR_SETTING } from "utils/generalSettingsHelpers"

export const formatAnswer = (answer) => {
  if (typeof answer === "number") {
    return answer
  }

  if (isEmpty(answer)) {
    return null
  }

  if (Array.isArray(answer)) {
    return answer.join(", ")
  }

  return answer
}

const ChangeInAnswer = ({ answerFrom = undefined, answerTo = undefined }) => {
  const clockFormat = useSelector(getClockFormat)

  if (answerFrom?.department_id || answerTo?.department_id) {
    return (
      <>
        <LocationDataElement value={answerFrom} />
        <p>→</p>
        <LocationDataElement value={answerTo} />
      </>
    )
  }

  if (answerFrom?.user_ids || answerTo?.user_ids) {
    return (
      <div className="screenreader-whitespace">
        <UsersAnswerDataElement value={answerFrom} />
        <p>→</p>
        <UsersAnswerDataElement value={answerTo} />
      </div>
    )
  }

  const answerFromIsTime = (typeof answerFrom === "string") && answerFrom.match(TWENTY_FOUR_HOUR_TIME_REGEX)
  const answerToIsTime = (typeof answerTo === "string") && answerTo.match(TWENTY_FOUR_HOUR_TIME_REGEX)

  if (clockFormat === CLOCK_FORMAT_TWELVE_HOUR_SETTING && (answerFromIsTime || answerToIsTime)) {
    return (
      <p>
        {answerFromIsTime ? timeByClockFormat(answerFrom, clockFormat) : answerFrom}
        →
        {answerToIsTime ? timeByClockFormat(answerTo, clockFormat) : answerTo}
      </p>
    )
  }

  return (
    <p>{formatAnswer(answerFrom)} → {formatAnswer(answerTo)}</p>
  )
}

const possibleAnswerTypes = [types.object, types.array, types.string, types.number]

ChangeInAnswer.propTypes = {
  answerFrom: types.oneOfType(possibleAnswerTypes),
  answerTo: types.oneOfType(possibleAnswerTypes),
}

export default ChangeInAnswer
